module.exports = __webpack_public_path__ + "img/Shanghai-speed.ca474a21.png";